
import React, { useContext, useState }  from 'react'

import Navbar from 'react-bootstrap/Navbar';

import {
    BrowserRouter as  Router,
    Route,
    Routes,
    
  } from "react-router-dom";


import { EnBlanco } from './EnBlanco';
import { Ingresar } from './Ingresar';
import { Cola } from './Cola';
import { Cola2 } from './Cola2';
import { CrearTicket } from './CrearTicket';
import { Modulo } from './Modulo';
import { TiposAtencion } from './TiposAtencion';
import { ModulosCreacion } from './Modulos-Creacion';
import { ModulosTipoAtencion } from './Modulos-TiposAtencion';
import { Usuarios } from './Usuarios';
import { Informes } from './Informes';
import { ListaPacientes } from './Lista-Pacientes';
import { Ingreso } from './Ingreso';
import { VideosLista } from "./Videos-Lista";

import { UiContext } from '../context/UiContext';
import { SideMenu } from '../components/sideMenu';
import { Salir } from '../components/salir';
import { ListaVideos } from './Lista-videos';
import { Encuestas } from './Encuestas';

export const RouterPage = () => {
    
    const { ocultarMenu } = useContext( UiContext )
    const [collapsed, setCollapsed] = useState(false);
    const [toggled, setToggled] = useState(false);
    
    const handleToggle = (toggle) =>{
        setToggled(toggle)
    }  
    
    return (


        <Router >
            <div  style={{   display: 'flex',   width: '100%' }} >


                    { ocultarMenu
                        ? ""
                        : (
                        
                            <>
                            
                                <SideMenu 
                                    ocultarMenu={ocultarMenu} 
                                    collapsed={collapsed} 
                                    toggled= {toggled}
                                    retToggleMenu = {handleToggle}
                                />
                                
                            </>

                        )
                    
                    }
                           
                <main  style={{ display: 'block', width: '100%', height: '100%', backgroundColor: 'white' }} >
                    

                  

                    { ocultarMenu
                        ? ""
                        : (
                        
                            <>
                                
                                <Navbar 
                                    // sticky='top'
                                    className=" justify-content-between"
                                    style= {{ backgroundColor: '#0b2948', color:'#8ba1b7', padding: '10px' }}
                                >
                                
                                    
                                        <Navbar.Brand
                                            onClick={() => {setCollapsed(!collapsed) }}
                                            style={{ color:'#8ba1b7' }}
                                            
                                            >
                                            <i className="fa-2x fa-solid fa-bars"></i>  
                                        </Navbar.Brand>   
                                      
                                        <Navbar.Brand  className="justify-content-end">
                                            <Salir />
                                        </Navbar.Brand>    
                                                    
                                   
                            
                                   
                                   
                                   
                                </Navbar>

                                
                                
                            </>

                        )
                    
                    }

                    
                        <Routes >
                            <Route path='/ingresar' Component={ Ingresar } />
                            <Route path='/cola' Component={ Cola } />
                            <Route path='/cola2' Component={ Cola2 } />
                            <Route path='/crear' Component={ CrearTicket } />
                            <Route path='/modulo' Component={ Modulo } />
                            <Route path='/tiposAtencion' Component={ TiposAtencion } />
                            <Route path='/modulos-creacion' Component={ ModulosCreacion } />
                            <Route path='/modulos-tiposAtencion' Component={ ModulosTipoAtencion } />
                            <Route path='/usuarios' Component={ Usuarios } />
                            {/* <Route path='/videos-lista' Component={ VideosLista } /> */}
                            <Route path='/informes' Component={ Informes } />
                            <Route path='/lista-Pacientes' Component={ ListaPacientes } />
                            <Route path='/*' Component={ Ingreso } />
                            <Route path='/inicio' Component={ EnBlanco } />
                            <Route path='/lista-videos' Component={ ListaVideos } />
                            <Route path='/encuestas' Component={ Encuestas } />
                            
                            {/* <Route path='/*' element={ <Navigate to='/ingresar'/> } /> */}
                        </Routes>

                
                    
                        { ocultarMenu
                        ? ""
                        : (
                        
                            <>

                                
                                <Navbar 
                                    fixed="bottom"
                                    className=" justify-content-between"
                                    style= {{ backgroundColor: '#0b2948', color:'#8ba1b7',}}
                                >
                                    <Navbar.Collapse 
                                        className=" justify-content-end"
                                       
                                    >
                                     <a href='https://www.pitsoluciones.com' target='_blank' >PITSoluciones.com</a>
                                    </Navbar.Collapse>
                                </Navbar>
                                
                            </>

                        )
                    
                    }
                </main>



                    

                       

            

            
            
            </div>
               
        </Router>
        
    )
}
